module.exports = __webpack_public_path__ + "img/short-term-savings-insurance.9995be2.png";